import * as React from 'react';
export const SvgFiletypeVector = (props) => {
    return (React.createElement("svg", { viewBox: '0 0 16 16', width: '1rem', height: '1rem', ...props },
        React.createElement("path", { d: 'M11 3V0H2v16h12V3z', fill: '#d16c00' }),
        React.createElement("path", { d: 'M11.966 9.63A3.96 3.96 0 0010.623 7H12V6H9.408a1.491 1.491 0 00-2.816 0H4v1h1.378a3.96 3.96 0 00-1.345 2.63.99.99 0 00-.533.87 1 1 0 002 0 .984.984 0 00-.47-.827 2.99 2.99 0 011.703-2.379 1.49 1.49 0 002.534 0 2.99 2.99 0 011.704 2.38.984.984 0 00-.471.826 1 1 0 002 0 .99.99 0 00-.534-.87zM8 7a.5.5 0 11.5-.5.5.5 0 01-.5.5z', fill: '#fff' }),
        React.createElement("path", { d: 'M14 3h-3V0z', fill: '#924b00' })));
};
export default SvgFiletypeVector;
